module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-04-0dc0653efec7754d7ebc88afa2d47213.svg";